(function() {
  "use strict";

  /**
   * Documentation Block Filter with Pagination
   */
  class DocumentationBlockFilter {
    constructor(element) {
      this.element = element;
      this.products = element.querySelectorAll(".documentation-block__product");
      console.log(this.products);
      this.documentTypeCheckboxes = element.querySelectorAll(
        'input[name="document_type[]"]'
      );
      this.categoryCheckboxes = element.querySelectorAll(
        'input[name="products_category[]"]'
      );
      this.brandCheckboxes = element.querySelectorAll('input[name="brand[]"]');

      // Pagination
      this.itemsPerPage = 10;
      this.currentPage = 1;
      this.filteredProducts = [];
      this.paginationContainer = element.querySelector(
        ".documentation-block__pagination"
      );
      this.paginationNumbers = element.querySelector(
        ".documentation-block__pagination-numbers"
      );
      this.prevButton = element.querySelector(
        ".documentation-block__pagination-prev"
      );
      this.nextButton = element.querySelector(
        ".documentation-block__pagination-next"
      );

      // Search
      this.searchInput = element.querySelector(
        ".documentation-block__search-input"
      );

      // Mobile filters
      this.mobileFiltersToggle = element.querySelector(
        ".documentation-block__mobile-filters-toggle"
      );
      this.mobileFiltersClose = element.querySelector(
        ".documentation-block__mobile-filters-close"
      );
      this.mobileBackButton = element.querySelector(
        ".documentation-block__mobile-back"
      );
      this.mobileFiltersCount = element.querySelector(
        ".documentation-block__mobile-filters-count"
      );
      this.filtersSidebar = element.querySelector(
        ".documentation-block__filters-sidebar"
      );
      this.mobileOverlay = element.querySelector(
        ".documentation-block__mobile-overlay"
      );

      // Selected filters
      this.selectedFiltersDocumentType = element.querySelector(
        '[data-filter-type="document-type"]'
      );
      this.selectedFiltersCategory = element.querySelector(
        '[data-filter-type="category"]'
      );
      this.selectedFiltersBrand = element.querySelector(
        '[data-filter-type="brand"]'
      );

      // Mobile bottom bar
      this.mobileFooter = element.querySelector(
        ".documentation-block__mobile-footer"
      );
      this.mobileFooterCount = element.querySelector(
        ".documentation-block__mobile-footer-count"
      );
      this.mobileClearFilters = element.querySelector(
        ".documentation-block__mobile-clear-filters"
      );
      this.mobileShowResults = element.querySelector(
        ".documentation-block__mobile-show-results"
      );

      // Mobile selected tags
      this.mobileSelectedTags = element.querySelector(
        ".documentation-block__mobile-selected-tags"
      );

      // Texts from data attributes
      this.mobileClearFiltersText =
        this.element.dataset.mobileClearFiltersText || "Wyczyść filtry";

      // ARIA texts from data attributes
      this.ariaTexts = {
        paginationNavigation:
          this.element.dataset.ariaPaginationNavigation ||
          "Nawigacja między stronami",
        paginationGroup:
          this.element.dataset.ariaPaginationGroup || "Wybór strony",
        prevPage: this.element.dataset.ariaPrevPage || "Poprzednia strona",
        nextPage: this.element.dataset.ariaNextPage || "Następna strona",
        prevUnavailable:
          this.element.dataset.ariaPrevUnavailable ||
          "Poprzednia strona - niedostępna",
        nextUnavailable:
          this.element.dataset.ariaNextUnavailable ||
          "Następna strona - niedostępna",
        currentPage:
          this.element.dataset.ariaCurrentPage ||
          "Strona {page}, aktualna strona",
        goToPage:
          this.element.dataset.ariaGoToPage || "Przejdź do strony {page}",
        prevGoTo:
          this.element.dataset.ariaPrevGoTo ||
          "Poprzednia strona, przejdź do strony {page}",
        nextGoTo:
          this.element.dataset.ariaNextGoTo ||
          "Następna strona, przejdź do strony {page}",
        searchProducts:
          this.element.dataset.ariaSearchProducts || "Wyszukiwanie produktów",
        searchButton: this.element.dataset.ariaSearchButton || "Szukaj produktu"
      };

      this.init();
    }

    init() {
      this.bindEvents();
      this.initializePagination();
      this.initializeCategoryToggle();
      this.initializeAriaLabels();
      this.initializeMobileFilters();

      // Hide mobile footer on start
      if (this.mobileFooter) {
        this.mobileFooter.classList.add("hidden");
      }

      // Hide mobile tags on start
      if (this.mobileSelectedTags) {
        this.mobileSelectedTags.classList.add("hidden");
      }

      // Initial filtering and pagination
      this.filterProducts();
    }

    bindEvents() {
      // Handle filtering by document types
      this.documentTypeCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
          // Reset page on filter change
          this.currentPage = 1;
          this.filterProducts();
          this.updateFiltersCount();
          this.updateSelectedFiltersDisplay();
        });
      });

      // Handle filtering by product categories
      this.categoryCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
          // Reset page on filter change
          this.currentPage = 1;
          this.filterProducts();
          this.updateFiltersCount();
          this.updateSelectedFiltersDisplay();
        });
      });

      // Handle filtering by brands
      this.brandCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
          // Reset page on filter change
          this.currentPage = 1;
          this.filterProducts();
          this.updateFiltersCount();
          this.updateSelectedFiltersDisplay();
        });
      });

      // Handle search
      if (this.searchInput) {
        this.searchInput.addEventListener("input", () => {
          // Reset page on search
          this.currentPage = 1;
          this.filterProducts();
        });

        // Handle search button
        const searchButton = this.element.querySelector(
          ".documentation-block__search-button"
        );

        if (searchButton) {
          searchButton.addEventListener("click", () => {
            // Focus on input for better UX
            this.searchInput.focus();
          });
        }
      }
    }

    initializePagination() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", () => {
          if (this.currentPage > 1) {
            this.currentPage--;
            this.updatePagination();
          }
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          const totalPages = Math.ceil(
            this.filteredProducts.length / this.itemsPerPage
          );

          if (this.currentPage < totalPages) {
            this.currentPage++;
            this.updatePagination();
          }
        });
      }
    }

    initializeCategoryToggle() {
      const categoryToggleButtons = this.element.querySelectorAll(
        ".documentation-block__category-toggle"
      );

      categoryToggleButtons.forEach(button => {
        button.addEventListener("click", event => {
          event.preventDefault();
          this.toggleCategory(button);
        });
      });

      // Handle "expand all" / "collapse all" buttons
      const expandAllButton = this.element.querySelector(
        ".documentation-block__expand-all"
      );
      const collapseAllButton = this.element.querySelector(
        ".documentation-block__collapse-all"
      );

      if (expandAllButton) {
        expandAllButton.addEventListener("click", () => {
          this.expandAllCategories();
        });
      }

      if (collapseAllButton) {
        collapseAllButton.addEventListener("click", () => {
          this.collapseAllCategories();
        });
      }
    }

    toggleCategory(toggleButton) {
      const categoryItem = toggleButton.closest(
        ".documentation-block__category-item"
      );
      const childrenContainer = categoryItem.querySelector(
        ".documentation-block__category-children"
      );

      if (!childrenContainer) {
        return;
      }

      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        // Collapse
        categoryItem.classList.remove(
          "documentation-block__category-item--expanded"
        );
        toggleButton.setAttribute("aria-expanded", "false");

        // Smooth collapse
        childrenContainer.style.maxHeight =
          childrenContainer.scrollHeight + "px";
        // Force reflow
        childrenContainer.offsetHeight;
        childrenContainer.style.maxHeight = "0";
        childrenContainer.style.opacity = "0";

        setTimeout(() => {
          if (
            !categoryItem.classList.contains(
              "documentation-block__category-item--expanded"
            )
          ) {
            childrenContainer.style.display = "none";
          }
        }, 300);
      } else {
        // Expand
        categoryItem.classList.add(
          "documentation-block__category-item--expanded"
        );
        toggleButton.setAttribute("aria-expanded", "true");

        // Smooth expand
        childrenContainer.style.display = "block";
        childrenContainer.style.maxHeight = "0";
        childrenContainer.style.opacity = "0";
        // Force reflow
        childrenContainer.offsetHeight;
        childrenContainer.style.maxHeight =
          childrenContainer.scrollHeight + "px";
        childrenContainer.style.opacity = "1";

        setTimeout(() => {
          if (
            categoryItem.classList.contains(
              "documentation-block__category-item--expanded"
            )
          ) {
            childrenContainer.style.maxHeight = "none";
          }
        }, 300);
      }
    }

    initializeAriaLabels() {
      // Set ARIA labels for pagination elements
      if (this.paginationContainer) {
        this.paginationContainer.setAttribute(
          "aria-label",
          this.ariaTexts.paginationNavigation
        );
      }

      if (this.paginationNumbers) {
        this.paginationNumbers.setAttribute(
          "aria-label",
          this.ariaTexts.paginationGroup
        );
      }

      // Set ARIA labels for search field
      if (this.searchInput) {
        this.searchInput.setAttribute(
          "aria-label",
          this.ariaTexts.searchProducts
        );
      }

      const searchButton = this.element.querySelector(
        ".documentation-block__search-button"
      );

      if (searchButton) {
        searchButton.setAttribute("aria-label", this.ariaTexts.searchButton);
      }
    }

    filterProducts() {
      const selectedDocumentTypes = this.getSelectedValues(
        this.documentTypeCheckboxes
      );
      const selectedCategories = this.getSelectedValues(
        this.categoryCheckboxes
      );
      const selectedBrands = this.getSelectedValues(this.brandCheckboxes);
      const searchTerm = this.searchInput
        ? this.searchInput.value.toLowerCase().trim()
        : "";

      // First hide all products
      this.products.forEach(product => {
        product.style.display = "none";
      });

      // Filter products and save to filteredProducts array
      this.filteredProducts = [];

      this.products.forEach(product => {
        // Check search by name and index
        if (searchTerm && !this.matchesSearchTerm(product, searchTerm)) {
          return;
        }

        const productCategories = this.getDataAttributes(product, "categories");
        const matchesCategory = this.matchesFilter(
          selectedCategories,
          productCategories
        );

        // If product doesn't match category, skip it
        if (!matchesCategory) {
          return;
        }

        const productBrands = this.getDataAttributes(product, "brands");
        const matchesBrand = this.matchesFilter(selectedBrands, productBrands);

        // If product doesn't match brand, skip it
        if (!matchesBrand) {
          return;
        }

        // Handle file filtering by document type
        const fileItems = product.querySelectorAll(
          ".documentation-block__file-item"
        );
        let hasVisibleFiles = false;

        fileItems.forEach(fileItem => {
          const fileDocumentType =
            fileItem.getAttribute("data-document-type") || "";

          // If no document types selected, show all files
          if (selectedDocumentTypes.length === 0) {
            fileItem.style.display = "";
            hasVisibleFiles = true;
          } else {
            // Show file only if its type is among selected
            if (selectedDocumentTypes.includes(fileDocumentType)) {
              fileItem.style.display = "";
              hasVisibleFiles = true;
            } else {
              fileItem.style.display = "none";
            }
          }
        });

        // Add product to filteredProducts if it has visible files
        if (hasVisibleFiles) {
          this.filteredProducts.push(product);
        }
      });

      this.updatePagination();
    }

    updatePagination() {
      const totalItems = this.filteredProducts.length;
      const totalPages = Math.ceil(totalItems / this.itemsPerPage);

      // Hide all products
      this.filteredProducts.forEach(product => {
        product.style.display = "none";
      });

      // Show products for current page
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const currentPageProducts = this.filteredProducts.slice(
        startIndex,
        endIndex
      );

      currentPageProducts.forEach(product => {
        product.style.display = "";
      });

      // Update navigation buttons
      if (this.prevButton) {
        this.prevButton.disabled = this.currentPage === 1;
        this.prevButton.setAttribute(
          "aria-label",
          this.currentPage === 1
            ? this.ariaTexts.prevUnavailable
            : this.ariaTexts.prevGoTo.replace("{page}", this.currentPage - 1)
        );
      }

      if (this.nextButton) {
        const isLastPage = this.currentPage === totalPages || totalPages === 0;

        this.nextButton.disabled = isLastPage;
        this.nextButton.setAttribute(
          "aria-label",
          isLastPage
            ? this.ariaTexts.nextUnavailable
            : this.ariaTexts.nextGoTo.replace("{page}", this.currentPage + 1)
        );
      }

      // Update page numbers
      this.updatePaginationNumbers(totalPages);

      // Show/hide pagination container
      if (this.paginationContainer) {
        this.paginationContainer.style.display = totalPages > 1 ? "" : "none";
      }
    }

    updatePaginationNumbers(totalPages) {
      if (!this.paginationNumbers) {
        return;
      }

      this.paginationNumbers.innerHTML = "";

      if (totalPages <= 1) {
        return;
      }

      const currentPage = this.currentPage;
      const pagesToShow = this.calculatePagesToShow(currentPage, totalPages);

      pagesToShow.forEach(item => {
        if (item.type === "page") {
          const pageButton = this.createPageButton(item.number);

          this.paginationNumbers.appendChild(pageButton);
        } else if (item.type === "ellipsis") {
          const ellipsis = this.createEllipsis();

          this.paginationNumbers.appendChild(ellipsis);
        }
      });
    }

    calculatePagesToShow(currentPage, totalPages) {
      const pages = [];

      if (totalPages <= 7) {
        // If few pages, show all
        for (let i = 1; i <= totalPages; i++) {
          pages.push({ type: "page", number: i });
        }

        return pages;
      }

      // Always add first page
      pages.push({ type: "page", number: 1 });

      // Calculate range around current page
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        pages.push({ type: "ellipsis" });
      }

      // Add pages around current
      for (let i = startPage; i <= endPage; i++) {
        pages.push({ type: "page", number: i });
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        pages.push({ type: "ellipsis" });
      }

      // Always add last page (if different from first)
      if (totalPages > 1) {
        pages.push({ type: "page", number: totalPages });
      }

      return pages;
    }

    createPageButton(pageNumber) {
      const pageButton = document.createElement("button");

      pageButton.className = "documentation-block__pagination-number";
      pageButton.textContent = pageNumber;

      if (pageNumber === this.currentPage) {
        pageButton.classList.add("active");
        pageButton.setAttribute("aria-current", "page");
        pageButton.setAttribute(
          "aria-label",
          this.ariaTexts.currentPage.replace("{page}", pageNumber)
        );
      } else {
        pageButton.setAttribute(
          "aria-label",
          this.ariaTexts.goToPage.replace("{page}", pageNumber)
        );
      }

      pageButton.addEventListener("click", () => {
        this.currentPage = pageNumber;
        this.updatePagination();
      });

      return pageButton;
    }

    createEllipsis() {
      const ellipsis = document.createElement("span");

      ellipsis.className = "documentation-block__pagination-ellipsis";
      ellipsis.textContent = "...";

      return ellipsis;
    }

    getSelectedValues(checkboxes) {
      const values = [];

      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          values.push(checkbox.value);
        }
      });

      return values;
    }

    getDataAttributes(element, attribute) {
      const data = element.dataset[this.toCamelCase(attribute)];

      return data ? data.split(" ").filter(item => item.length > 0) : [];
    }

    toCamelCase(str) {
      return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
    }

    matchesSearchTerm(product, searchTerm) {
      // Get product name
      const productNameElement = product.querySelector(
        ".documentation-block__product-name"
      );
      const productName = productNameElement
        ? productNameElement.textContent.toLowerCase()
        : "";
      // Get product indexes
      const productIndexes = this.getDataAttributes(product, "indexes");
      const indexesText = productIndexes.join(" ").toLowerCase();

      // Check if search term matches name or indexes
      return (
        productName.includes(searchTerm) || indexesText.includes(searchTerm)
      );
    }

    matchesFilter(selectedValues, productValues) {
      // If no filters selected, show all products
      if (selectedValues.length === 0) {
        return true;
      }

      // Check if at least one of the selected filters matches the product
      return selectedValues.some(selectedValue =>
        productValues.includes(selectedValue)
      );
    }

    expandAllCategories() {
      const expandableItems = this.element.querySelectorAll(
        ".documentation-block__category-item--expandable"
      );

      expandableItems.forEach(item => {
        const toggleButton = item.querySelector(
          ".documentation-block__category-toggle"
        );
        const isExpanded =
          toggleButton.getAttribute("aria-expanded") === "true";

        if (!isExpanded) {
          this.toggleCategory(toggleButton);
        }
      });
    }

    collapseAllCategories() {
      const expandableItems = this.element.querySelectorAll(
        ".documentation-block__category-item--expandable"
      );

      expandableItems.forEach(item => {
        const toggleButton = item.querySelector(
          ".documentation-block__category-toggle"
        );
        const isExpanded =
          toggleButton.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          this.toggleCategory(toggleButton);
        }
      });
    }

    updateSelectedFiltersDisplay() {
      this.updateSelectedFiltersForType(
        this.documentTypeCheckboxes,
        this.selectedFiltersDocumentType
      );
      this.updateSelectedFiltersForType(
        this.categoryCheckboxes,
        this.selectedFiltersCategory
      );
      this.updateSelectedFiltersForType(
        this.brandCheckboxes,
        this.selectedFiltersBrand
      );
      this.renderMobileSelectedTags();
    }

    updateSelectedFiltersForType(checkboxes, displayElement) {
      if (!displayElement) {
        return;
      }

      // Clear container
      displayElement.innerHTML = "";

      const selectedFilters = [];

      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const label = checkbox.closest("label");

          if (label) {
            const labelText = label.textContent.trim();

            selectedFilters.push({
              name: labelText,
              checkbox: checkbox
            });
          }
        }
      });

      if (selectedFilters.length === 0) {
        return;
      }

      // Create tags for each selected filter
      selectedFilters.forEach((filter, index) => {
        const tag = document.createElement("span");

        tag.className = "documentation-block__filter-tag";
        tag.textContent = filter.name;

        // Add spacing between elements (margin-right for all except last)
        if (index < selectedFilters.length - 1) {
          tag.style.marginRight = "2px";
        }

        displayElement.appendChild(tag);
      });
    }

    renderMobileSelectedTags() {
      console.log("renderMobileSelectedTags called");

      if (!this.mobileSelectedTags) {
        console.log("mobileSelectedTags element not found");

        return;
      }

      // Collect all selected filters
      const selectedFilters = [];

      // Add selected document types
      this.documentTypeCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const label = checkbox.closest("label");

          if (label) {
            selectedFilters.push({
              name: label.textContent.trim(),
              type: "document-type",
              checkbox: checkbox
            });
          }
        }
      });

      // Add selected categories
      this.categoryCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const label = checkbox.closest("label");

          if (label) {
            selectedFilters.push({
              name: label.textContent.trim(),
              type: "category",
              checkbox: checkbox
            });
          }
        }
      });

      // Add selected brands
      this.brandCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const label = checkbox.closest("label");

          if (label) {
            selectedFilters.push({
              name: label.textContent.trim(),
              type: "brand",
              checkbox: checkbox
            });
          }
        }
      });

      // Wyczyść kontener
      this.mobileSelectedTags.innerHTML = "";

      if (selectedFilters.length === 0) {
        console.log("No filters selected, hiding container");
        // Hide container when no filters
        this.mobileSelectedTags.classList.add("hidden");

        return;
      }

      // Show container when there are filters
      console.log(`Found ${selectedFilters.length} filters, showing container`);
      this.mobileSelectedTags.classList.remove("hidden");

      // Display first two filters with names
      selectedFilters.slice(0, 2).forEach(filter => {
        const tag = document.createElement("span");

        tag.className = "documentation-block__mobile-tag";
        tag.innerHTML = `
          ${filter.name}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.25 2.25L9.75 9.75M2.25 9.75L9.75 2.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        // Add event listener to remove filter
        tag.addEventListener("click", () => {
          filter.checkbox.checked = false;
          this.currentPage = 1;
          this.filterProducts();
          this.updateFiltersCount();
          this.updateSelectedFiltersDisplay();
        });

        this.mobileSelectedTags.appendChild(tag);
      });

      // If there are more than 2 filters, add +X element
      if (selectedFilters.length > 2) {
        const moreTag = document.createElement("span");

        moreTag.className =
          "documentation-block__mobile-tag documentation-block__mobile-tag--more";
        moreTag.textContent = `+${selectedFilters.length - 2}`;
        this.mobileSelectedTags.appendChild(moreTag);
      }

      // Add link to clear filters
      const clearLink = document.createElement("button");

      clearLink.className =
        "documentation-block__mobile-tag documentation-block__mobile-tag--clear";
      clearLink.textContent = this.mobileClearFiltersText;
      clearLink.type = "button";

      clearLink.addEventListener("click", e => {
        e.preventDefault();
        this.clearAllFilters();
      });

      this.mobileSelectedTags.appendChild(clearLink);
    }

    updateFiltersCount() {
      if (!this.mobileFiltersCount) {
        return;
      }

      const selectedDocumentTypes = this.getSelectedValues(
        this.documentTypeCheckboxes
      );
      const selectedCategories = this.getSelectedValues(
        this.categoryCheckboxes
      );
      const selectedBrands = this.getSelectedValues(this.brandCheckboxes);
      const totalFilters =
        selectedDocumentTypes.length +
        selectedCategories.length +
        selectedBrands.length;

      this.mobileFiltersCount.textContent = `(${totalFilters})`;

      // Update counter in bottom bar
      if (this.mobileFooterCount) {
        this.mobileFooterCount.textContent = totalFilters;
      }

      // Show/hide bottom bar depending on number of filters
      if (this.mobileFooter) {
        if (totalFilters > 0) {
          this.mobileFooter.classList.remove("hidden");
        } else {
          this.mobileFooter.classList.add("hidden");
        }
      }
    }

    initializeMobileFilters() {
      if (this.mobileFiltersToggle) {
        this.mobileFiltersToggle.addEventListener("click", () => {
          this.openMobileFilters();
        });
      }

      if (this.mobileFiltersClose) {
        this.mobileFiltersClose.addEventListener("click", () => {
          this.closeMobileFilters();
        });
      }

      if (this.mobileBackButton) {
        this.mobileBackButton.addEventListener("click", () => {
          this.closeMobileFilters();
        });
      }

      if (this.mobileOverlay) {
        this.mobileOverlay.addEventListener("click", () => {
          this.closeMobileFilters();
        });
      }

      // Handle bottom bar buttons
      if (this.mobileClearFilters) {
        this.mobileClearFilters.addEventListener("click", e => {
          e.preventDefault();
          this.clearAllFilters();
        });
      }

      if (this.mobileShowResults) {
        this.mobileShowResults.addEventListener("click", e => {
          e.preventDefault();
          this.closeMobileFilters();
        });
      }

      // Close filters on ESC press
      document.addEventListener("keydown", e => {
        if (e.key === "Escape" && this.isMobileFiltersOpen()) {
          this.closeMobileFilters();
        }
      });
    }

    openMobileFilters() {
      if (this.filtersSidebar && this.mobileOverlay) {
        this.filtersSidebar.classList.add("active");
        this.mobileOverlay.classList.add("active");
        document.body.style.overflow = "hidden";

        // Hide header and main content
        const topHeader = document.querySelector(".c-top-header");
        const siteContent = document.querySelector(".o-site");

        if (topHeader) {
          topHeader.style.display = "none";
        }

        if (siteContent) {
          siteContent.style.display = "none";
        }

        // Update filters count and display
        this.updateFiltersCount();
        this.updateSelectedFiltersDisplay();
      }
    }

    closeMobileFilters() {
      if (this.filtersSidebar && this.mobileOverlay) {
        this.filtersSidebar.classList.remove("active");
        this.mobileOverlay.classList.remove("active");
        document.body.style.overflow = "";

        // Restore visibility of header and main content
        const topHeader = document.querySelector(".c-top-header");
        const siteContent = document.querySelector(".o-site");

        if (topHeader) {
          topHeader.style.display = "";
        }

        if (siteContent) {
          siteContent.style.display = "";
        }
      }
    }

    // Alias for better readability in "show results" context
    hideMobileFilters() {
      this.closeMobileFilters();
    }

    isMobileFiltersOpen() {
      return (
        this.filtersSidebar && this.filtersSidebar.classList.contains("active")
      );
    }

    // Method to clear all filters
    clearAllFilters() {
      // Clear all checkboxes
      const allCheckboxes = this.filtersSidebar.querySelectorAll(
        'input[type="checkbox"]:checked'
      );

      allCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
      });

      // Clear all displayed filters
      const allSelectedFilters = this.filtersSidebar.querySelectorAll(
        ".documentation-block__filters-selected"
      );

      allSelectedFilters.forEach(container => {
        container.innerHTML = "";
      });

      // Reset page to first
      this.currentPage = 1;

      // Update filters count
      this.updateFiltersCount();

      // Update selected filters display (including mobile tags)
      this.updateSelectedFiltersDisplay();

      // Clear search input
      if (this.searchInput) {
        this.searchInput.value = "";
      }

      // Update search results
      this.filterProducts();
    }
  }

  // Initialize after document load
  document.addEventListener("DOMContentLoaded", function() {
    const documentationBlocks = document.querySelectorAll(
      ".documentation-block"
    );

    documentationBlocks.forEach(block => {
      new DocumentationBlockFilter(block);
    });
  });
})();
